import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import Footer from '../components/landing/Footer';
import {
  iOSDownloadURL,
  androidDownloadURL,
  playstoreDownloadURL,
} from '../components/ImageWrapper/ImageWrapper';

const VERSION = '0.5.0';

export default function Install() {
  const router = useRouter();
  const comingFromWebOnInstallation = 'comingFromWebOnInstallation' in router.query;

  return (
    <>
      <NextSeo title="Download Nomo" description="Download the newest version of Nomo." />

      <main>
        <section className="cta-section" id="install" style={{ paddingTop: '8rem' }}>
          <div className="container" style={{ position: 'relative', zIndex: 1 }}>
            <div className="glass-wrap">
              <div className="cta-section__eyebrow">Download</div>

              <h1 className="cta-section__title">
                <span style={{ color: 'var(--white)' }}>Get</span>{' '}
                <span className="gradient-text" style={{ fontFamily: "'Orbitron', sans-serif" }}>NOMO</span>
                <br />
                <span style={{ color: 'var(--white)' }}>on every platform.</span>
              </h1>

              <p className="cta-section__sub">
                {comingFromWebOnInstallation
                  ? "It looks like Nomo isn't installed yet. Download the app below, then re-open the WebOn installation link."
                  : 'Secure. Elegant. Sovereign. Available on mobile and desktop.'}
              </p>

              <div className="hero__cta">
                <a
                  href={iOSDownloadURL}
                  className="btn btn-outline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg className="btn__store-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                  </svg>
                  <span className="btn__store-text">
                    <span className="btn__store-label">Download on the</span>
                    <span className="btn__store-name">App Store</span>
                  </span>
                </a>

                <a
                  href={playstoreDownloadURL}
                  className="btn btn-outline btn-outline--ccw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg className="btn__store-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M3 20.5v-17c0-.59.34-1.11.84-1.35L13.69 12l-9.85 9.85c-.5-.25-.84-.76-.84-1.35zm13.81-5.38L6.05 21.34l8.49-8.49 2.27 2.27zM20.16 10.81c.34.27.59.69.59 1.19s-.22.9-.57 1.18l-2.29 1.32-2.5-2.5 2.5-2.5 2.27 1.31zM6.05 2.66l10.76 6.22-2.27 2.27L6.05 2.66z" />
                  </svg>
                  <span className="btn__store-text">
                    <span className="btn__store-label">Get it on</span>
                    <span className="btn__store-name">Google Play</span>
                  </span>
                </a>
              </div>

              <div className="cta-section__badges" style={{ marginTop: '2.5rem' }}>
                <span className="cta-badge">Beta · v{VERSION}</span>
                <span className="cta-badge">Self-Custodial</span>
                <span className="cta-badge">Encrypted</span>
                <span className="cta-badge">Multi-Chain</span>
                <span className="cta-badge">Free to Download</span>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
